import CryptoJS from 'crypto-js';
import config from '../appconfig/config.json';
import mbCards from '../data/mayBankCardBIN.json';


const encrypt = (text) => {
    //   return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(text));
    return CryptoJS.AES.encrypt(text, config.SECRET_KEY).toString();
};

const decrypt = (ciphertext) => {
    //   return CryptoJS.enc.Base64.parse(data).toString(CryptoJS.enc.Utf8);
    let originalText = '';
    let bytes = CryptoJS.AES.decrypt(ciphertext, config.SECRET_KEY);

    originalText = bytes.toString(CryptoJS.enc.Utf8);
    return originalText;
};


const SOURCE_TO_HOME_QUERY = Object.freeze({
    [config.SRC_CODE_HNW]: '?p=U2FsdGVkX18njfeygnz2PJtTtbOsoJt29npOcJgM0kM',
    [config.SRC_CODE_CCFT03]: '?p=U2FsdGVkX191x3XcxVyb8riWQnTBPFuRJiTnzJ8lPrw',
    [config.SRC_CODE_CCFT04]: '?p=U2FsdGVkX19spgrgxtU55243WOzLbGULj44RaIl8bt0',
    [config.SRC_CODE_CCFT05]: '?p=U2FsdGVkX19SmWK3JZEXKKbjFwVaxznXadU9IVKiIu4',
    [config.SRC_CODE_CCFT06]: '?p=U2FsdGVkX19sSvYm2kWiDBUET64zAsU95ppkcHpDKFc',
    [config.SRC_CODE_CCFT]: '?p=U2FsdGVkX186eY9LS3f6elp6OcUvVL2o1UliENaneSo',
    [config.SRC_CODE_OUTSIDERS]: '?p=U2FsdGVkX18R2Kokj3yUy3XUW1PSktWTmpwJt0CZPpg'
});

const SOURCE_TO_MIN_AMT = Object.freeze({
    [config.SRC_CODE_HNW]: 2000,
    [config.SRC_CODE_OUTSIDERS]: 2000,
    [config.SRC_CODE_CCFT03]: 2000,
    [config.SRC_CODE_CCFT04]: 2000,
    [config.SRC_CODE_CCFT]: 1000,
    [config.SRC_CODE_CCFT05]: 1000,
    [config.SRC_CODE_CCFT06]: 1000
});

const ENV_TO_HOME_URL = Object.freeze({
    SIT: config.URL_ToHomeScreen_SIT,
    UAT: config.URL_ToHomeScreen_UAT,
    PROD: config.URL_ToHomeScreen_PROD
});

const getSourceParam = () => localStorage.getItem('p');

const isMayBankCardBINList = (value) => mbCards.includes(value);
// const isMayBankCardBINList = (value) => {
//     let isMBCard = false;
//     for (let i in mbCards) {
//         if (value === mbCards[i]) {
//             isMBCard = true;
//             return isMBCard
//         }
//     }

//     return isMBCard
// }

const toHomeScreen = () => {
    const source = getSourceParam();
    const querystr = SOURCE_TO_HOME_QUERY[source] || '';
    const baseurl = ENV_TO_HOME_URL[config.SERVER_STATUS] || '';

    if (baseurl) {
        document.location.href = baseurl + querystr;
    }
};

const AMT_NOTE_FORMATTER = new Intl.NumberFormat('en-SG', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
});

const displayAmtNote = () => {
    const source = getSourceParam();
    const amount = SOURCE_TO_MIN_AMT[source];
    if (amount == null) return '';

    return `S$${AMT_NOTE_FORMATTER.format(amount)}`;
};

// const displayAmtNote = () => {
//     let params = localStorage.getItem('p');
//     let str = '';
//     if (params) { // Apr 2024
//         if (params === config.SRC_CODE_HNW || params === config.SRC_CODE_OUTSIDERS || params === config.SRC_CODE_CCFT03 || params === config.SRC_CODE_CCFT04) {
//             str = 'S$2,000';
//         } else if (params === config.SRC_CODE_CCFT || params === config.SRC_CODE_CCFT05 || params === config.SRC_CODE_CCFT06) {
//             str = 'S$1,000';
//         }
//     }

//     return str;
// }


const getAmtValidValue = () => {
    const source = getSourceParam();
    return SOURCE_TO_MIN_AMT[source] ?? 2000;
};

export default {
    encrypt,
    decrypt,
    isMayBankCardBINList,
    toHomeScreen,
    displayAmtNote,
    getAmtValidValue
}